/* tslint:disable */
/* eslint-disable */
/**
 * 80s Conservation Club REST API
 * 80s Conservation Club REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: graham@matthewsapps.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Rename Campsite Schema
 * @export
 * @interface RenameCampsiteRequest
 */
export interface RenameCampsiteRequest {
    /**
     * Campsite Number
     * @type {string}
     * @memberof RenameCampsiteRequest
     */
    number: string;
}

/**
 * Check if a given object implements the RenameCampsiteRequest interface.
 */
export function instanceOfRenameCampsiteRequest(value: object): value is RenameCampsiteRequest {
    if (!('number' in value) || value['number'] === undefined) return false;
    return true;
}

export function RenameCampsiteRequestFromJSON(json: any): RenameCampsiteRequest {
    return RenameCampsiteRequestFromJSONTyped(json, false);
}

export function RenameCampsiteRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenameCampsiteRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
    };
}

export function RenameCampsiteRequestToJSON(value?: RenameCampsiteRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'number': value['number'],
    };
}

